export enum CoverageState {
    running     = "running",
    finished    = "finished",
    aborted     = "aborted",
  }

export const getCoverageStateTradKey = (covState?:CoverageState|null) => {
    switch(covState){        
        case CoverageState.finished: return "CoverageState.Finished"
        case CoverageState.aborted: return "CoverageState.Aborted"
        default: return "CoverageState.Running"
    }
}

export const getCoverageState = (covState?:string|null) => {
    switch(covState) {
        //case "running": return SimulationStatus.running
        case "finished": return CoverageState.finished
        case "aborted": return CoverageState.aborted
        default: return CoverageState.running
    }
}